// utils/index.js
const A_MINUTE = 60000
const AN_HOUR = 3600000
const A_DAY = 86400000

export function queryString(param = {}, encode = true) {
  return Object.keys(param).map(key => {
    let value = typeof param[key] === 'object' ? JSON.stringify(param[key]) : param[key]
    if (encode) value = encodeURIComponent(value)
    return `${key}=${value}`
  }).join('&')
}


/**
 * 数字转字符串补0
 * @param {!number} val
 */
export function add0 (val) {
  const n = val.toString()
  return n[1] ? n : '0' + n
}

/**
 * 格式化
 */
function _format (date, str) {
  if (!(date instanceof Date)) {
    date = new Date(date)
  }
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  }
  if (/(y+)/.test(str)) {
    str = str.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(str)) {
      str = str.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[ k ]).substr(('' + o[ k ]).length))
    }
  }
  return str
}

export function timeSince (dateStr, formatStr) {
  dateStr = dateStr + ''
  dateStr *= (dateStr.length === 10 ? 1000 : 1)
  if (!dateStr) {
    return ''
  }
  var date = new Date(dateStr)
  var recorded = date.valueOf()
  var today = new Date().setHours(0, 0, 0, 0)
  var yesterday = today - A_DAY
  var theDayBefore = yesterday - A_DAY
  var now = new Date().valueOf()
  var diffFromRecorded = now - recorded

  if (diffFromRecorded < A_MINUTE) {
    return '刚刚'
  }

  if (diffFromRecorded < AN_HOUR) {
    return parseInt(diffFromRecorded / A_MINUTE) + '分钟前'
  }

  if (diffFromRecorded < now - today) {
    return parseInt(diffFromRecorded / AN_HOUR) + '小时前'
  }
  if (diffFromRecorded < now - yesterday) {
    return _format(dateStr, '昨天 hh:mm')
  }
  if (diffFromRecorded < now - theDayBefore) {
    return _format(dateStr, '前天 hh:mm')
  }
  return _format(dateStr, formatStr || 'yyyy-MM-dd hh:mm')
}

export function parseQueryString (string) {
  const [, queryString] = string.split('?')
  if (!queryString) {
    return {}
  } else {
    const obj = {}
    queryString.split('&').forEach(pair => {
      const [key, value] = pair.split('=')
      obj[key] = decodeURIComponent(value)
    })
    return obj
  }
}